import http from 'utils/http';
import { getAgencySmsLogUrl, getAgencySmsLogsUrl } from './apiUrls';
import { AgencySmsLogResponse, AgencySmsLogsListResponse } from './types';

export function getAgencySmsLogs(params?: Record<string, unknown>): Promise<AgencySmsLogsListResponse> {
  return http.get(getAgencySmsLogsUrl(), params);
}

export function getAgencySmsLog(id: number | string, params?: Record<string, unknown>): Promise<AgencySmsLogResponse> {
  return http.get(getAgencySmsLogUrl(id), params);
}
